import { useState, useCallback } from 'react';
import { supabase } from '@/lib/customSupabaseClient';

export function useAIAssistant() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const invoke = useCallback(async (action, params) => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: fnError } = await supabase.functions.invoke('live-studio-ai', {
        body: { action, ...params },
      });
      if (fnError) throw fnError;
      if (data?.error) throw new Error(data.error);
      return data?.result ?? '';
    } catch (err) {
      const msg = err?.message || 'AI request failed';
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const translate = useCallback(
    (text, targetLanguage) => invoke('translate', { text, target_language: targetLanguage }),
    [invoke]
  );

  const fixGrammar = useCallback(
    (text, language) => invoke('grammar', { text, language }),
    [invoke]
  );

  const generateReply = useCallback(
    ({ athleteNote, exerciseName, painLevel, rpe, language }) =>
      invoke('generate_reply', {
        athlete_note: athleteNote,
        exercise_name: exerciseName,
        pain_level: painLevel,
        rpe,
        language,
      }),
    [invoke]
  );

  return { translate, fixGrammar, generateReply, loading, error };
}
